/*
  A/B purchase box for the ToeGrips product page - Figma node 4003-2.

  Isolation contract (this runs alongside the control form on the same page):
    * Everything is inside an IIFE. The control script
      (`npa-size-recommendation-with-weights-toegrip-updated.js`) and
      `custom-recharge-widget.liquid` both declare top-level `let`/`function`
      names - `sizeids`, `breedsizes`, `abAtcButton`, `dogBreedChosen`,
      `is_iOS`, `currentSelectionType`, `freqButtons`, ... A single shared name
      would throw a redeclaration SyntaxError and take out a whole script block.
    * Every DOM lookup is scoped to `#tgab-box`.
    * We never touch Recharge's injected widget. Subscriptions are submitted as
      a native `selling_plan` on our own form, so the control's Recharge proxy
      and this box cannot desync each other.
*/
(function () {
  'use strict';

  var box = document.getElementById('tgab-box');
  if (!box) return;

  /* Size -> swatch colour. The variant-data blob is keyed by handleized variant
     title (`xs-yellow`), matching the control's `{{ value | handle }}-swatch`. */
  var SIZES = [
    { key: 'XS',   color: 'yellow', label: 'Extra Small' },
    { key: 'S',    color: 'red',    label: 'Small' },
    { key: 'M',    color: 'blue',   label: 'Medium' },
    { key: 'L',    color: 'green',  label: 'Large' },
    { key: 'XL',   color: 'purple', label: 'Extra Large' },
    { key: 'XXL',  color: 'orange', label: 'XX-Large' },
    { key: 'XXXL', color: 'navy',   label: 'XXX-Large' }
  ];

  var MIN_QUERY_LENGTH = 3;

  var WARN_NO_BREED =
    "Select a breed by typing your dog's breed above. If no matches are found, " +
    "choose the closest breed and select your dog's weight range in the next step.";
  var WARN_NO_WEIGHT = "Select your dog's weight range above to get a recommended size.";
  var WARN_NO_SIZE =
    'Choose a ToeGrips size above to purchase. If you don’t know your dog’s size, ' +
    'click “By Breed & Weight” above and use our fit finder to help.';

  function $(sel) {
    return box.querySelector(sel);
  }

  function $$(sel) {
    return Array.prototype.slice.call(box.querySelectorAll(sel));
  }

  var els = {
    form:         $('form'),
    variantId:    $('#tgab-variant-id'),
    sellingPlan:  $('#tgab-selling-plan'),
    breedProp:    $('#tgab-breed-property'),
    weightProp:   $('#tgab-weight-property'),
    panelBreed:   $('#tgab-panel-breed'),
    panelChart:   $('#tgab-panel-chart'),
    breedInput:   $('#tgab-breed-input'),
    suggestions:  $('#tgab-suggestions'),
    step2:        $('#tgab-step-2'),
    weightGrid:   $('#tgab-weight-grid'),
    result:       $('#tgab-result'),
    resultBadge:  $('#tgab-result-badge'),
    resultCopy:   $('#tgab-result-copy'),
    planOnetime:  $('#tgab-plan-onetime'),
    planSub:      $('#tgab-plan-sub'),
    onetimePrice: $('#tgab-onetime-price'),
    subPrice:     $('#tgab-sub-price'),
    subCompare:   $('#tgab-sub-compare'),
    saveBadge:    $('#tgab-save-badge'),
    frequency:    $('#tgab-frequency'),
    freqGrid:     $('#tgab-freq-grid'),
    warning:      $('#tgab-warning'),
    submit:       $('#tgab-submit'),
    submitLabel:  $('#tgab-submit span'),
    quantity:     $('#tgab-quantity'),
    qtyWrap:      $('.tgab-qty')
  };

  if (!els.form || !els.breedInput) return;

  var variants = (function () {
    var node = $('#tgab-variant-data');
    if (!node) return {};
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return {};
    }
  })();

  /* Breed data is rendered once by the section (`#NPAjson`). We only read it, so
     there is no second copy and no duplicate id. */
  var breeds = (function () {
    var node = document.getElementById('NPAjson');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return [];
    }
  })();

  var state = {
    mode: 'breed',        // 'breed' | 'chart'
    breed: null,
    sizeKey: null,
    plan: 'onetime',      // 'onetime' | 'subscribe'
    weeks: 6,
    highlighted: -1
  };

  /* ------------------------------------------------------------- utilities */

  function sizeByKey(key) {
    for (var i = 0; i < SIZES.length; i++) {
      if (SIZES[i].key === key) return SIZES[i];
    }
    return null;
  }

  function variantForSize(key) {
    var size = sizeByKey(key);
    if (!size) return null;

    var wanted = (key + '-' + size.color).toLowerCase();
    if (variants[wanted]) return variants[wanted];

    /* Keys come from `variant.title | handle`, which is exactly `xs-yellow` while
       Size is the only option. If a second option is ever added the handle gains
       a suffix, so fall back to a prefix match instead of failing shut. */
    var keys = Object.keys(variants);
    for (var i = 0; i < keys.length; i++) {
      if (keys[i].indexOf(wanted) === 0) return variants[keys[i]];
    }
    return null;
  }

  /* Selling plan whose name mentions the wanted cadence, e.g. "every 6 weeks". */
  function planForWeeks(variant, weeks) {
    if (!variant || !variant.plans || !variant.plans.length) return null;
    for (var i = 0; i < variant.plans.length; i++) {
      var digits = String(variant.plans[i].name).match(/\d+/);
      if (digits && parseInt(digits[0], 10) === weeks) return variant.plans[i];
    }
    return null;
  }

  function displayBreed(name) {
    return name === "I don't know" ? 'dog' : name;
  }

  function weightRangesFor(breed) {
    var ranges = [];
    for (var i = 1; i <= 7; i++) {
      var pair = breed['size' + i];
      if (pair) ranges.push({ size: pair[0], range: pair[1] });
    }
    return ranges;
  }

  function setEnabled(input, value) {
    if (!input) return;
    if (value === null || value === undefined || value === '') {
      input.value = '';
      input.disabled = true;   // disabled inputs are not submitted
    } else {
      input.value = value;
      input.disabled = false;
    }
  }

  function hideWarning() {
    if (els.warning) els.warning.hidden = true;
  }

  function showWarning(text) {
    if (!els.warning) return;
    els.warning.textContent = text;
    els.warning.hidden = false;
  }

  /* ---------------------------------------------------------- pricing / cta */

  /* A size has resolved to a buyable variant. This gates the frequency block and
     the quantity stepper - deliberately NOT `isComplete()`, which also depends on
     the chosen plan: gating on that would hide the frequency block whenever a
     cadence had no matching selling plan, leaving no way back to One-Time. */
  function hasSize() {
    var variant = variantForSize(state.sizeKey);
    return !!(variant && variant.available);
  }

  function isComplete() {
    if (!hasSize()) return false;
    if (state.plan === 'subscribe') {
      return !!planForWeeks(variantForSize(state.sizeKey), state.weeks);
    }
    return true;
  }

  /* Whether the frequency block and quantity stepper are shown.

     The design treats the two modes differently: the size chart shows both up
     front (one click is all it takes there), while the breed flow defers them
     until its two steps have produced a size, so step 1 stays uncluttered. */
  function showsPurchaseControls() {
    return state.mode === 'chart' || hasSize();
  }

  function missingReason() {
    if (state.mode === 'chart') return WARN_NO_SIZE;
    if (!state.breed) return WARN_NO_BREED;
    if (!state.sizeKey) return WARN_NO_WEIGHT;
    return WARN_NO_SIZE;
  }

  function ctaLabel() {
    if (isComplete()) {
      return state.plan === 'subscribe' ? 'Subscribe Now' : 'Add to Cart';
    }
    if (state.mode === 'chart') return 'Choose a Size to Continue';
    if (!state.breed) return 'Select Breed to Begin';
    return 'Select Size to Continue';
  }

  function syncPrices() {
    var variant = variantForSize(state.sizeKey);
    var reference = variant || variants[Object.keys(variants)[0]] || null;

    if (els.onetimePrice && reference) {
      els.onetimePrice.textContent = reference.price_money;
    }

    var plan = reference ? planForWeeks(reference, state.weeks) : null;
    var hasPlans = !!(reference && reference.plans && reference.plans.length);

    /* No native selling plans on this product -> no subscription option at all,
       rather than a button that cannot add to cart. */
    if (els.planSub) els.planSub.hidden = !hasPlans;
    if (!hasPlans && state.plan === 'subscribe') {
      state.plan = 'onetime';
      syncPlanUi();
    }

    if (plan) {
      if (els.subPrice) els.subPrice.textContent = plan.price_money;
      if (els.subCompare) {
        var showCompare = plan.compare_at && plan.compare_at > plan.price;
        els.subCompare.textContent = showCompare ? plan.compare_at_money : '';
        els.subCompare.hidden = !showCompare;
      }
      if (els.saveBadge && plan.compare_at && plan.compare_at > plan.price) {
        var pct = Math.round(((plan.compare_at - plan.price) / plan.compare_at) * 100);
        els.saveBadge.textContent = 'Save ' + pct + '%';
        els.saveBadge.hidden = false;
      } else if (els.saveBadge) {
        els.saveBadge.hidden = true;
      }
    }

    /* Grey out cadences this variant has no plan for. */
    if (reference) {
      $$('.tgab-freq-btn').forEach(function (btn) {
        var weeks = parseInt(btn.getAttribute('data-weeks'), 10);
        var available = !!planForWeeks(reference, weeks);
        btn.classList.toggle('is-unavailable', !available);
        btn.setAttribute('aria-disabled', available ? 'false' : 'true');
      });
    }
  }

  function syncForm() {
    var variant = variantForSize(state.sizeKey);
    setEnabled(els.variantId, variant ? variant.id : null);

    var plan = null;
    if (variant && state.plan === 'subscribe') plan = planForWeeks(variant, state.weeks);
    setEnabled(els.sellingPlan, plan ? plan.id : null);

    setEnabled(els.breedProp, state.breed ? state.breed.name : null);

    var activeWeight = $('.tgab-weight-btn.is-active');
    setEnabled(els.weightProp, activeWeight ? activeWeight.textContent.trim() : null);

    var complete = isComplete();
    if (els.submit) {
      els.submit.classList.toggle('is-blocked', !complete);
      els.submit.setAttribute('aria-disabled', complete ? 'false' : 'true');
    }
    if (els.submitLabel) els.submitLabel.textContent = ctaLabel();

    /* While these are hidden the CTA spans the full row on its own (flex: 1 1 auto).
       Quantity resets to 1 whenever no size is held, so a stale count can never be
       submitted from a hidden field after the selection changes. */
    var showControls = showsPurchaseControls();
    if (els.frequency) els.frequency.hidden = !showControls;
    if (els.qtyWrap) els.qtyWrap.hidden = !showControls;
    if (!hasSize() && els.quantity) els.quantity.value = 1;

    syncPrices();
    if (complete) hideWarning();
  }

  /* --------------------------------------------------------------- plan ui */

  function syncPlanUi() {
    if (els.planOnetime) {
      var onetime = state.plan === 'onetime';
      els.planOnetime.classList.toggle('is-active', onetime);
      els.planOnetime.setAttribute('aria-pressed', String(onetime));
    }
    if (els.planSub) {
      var sub = state.plan === 'subscribe';
      els.planSub.classList.toggle('is-active', sub);
      els.planSub.setAttribute('aria-pressed', String(sub));
    }
  }

  function selectPlan(plan) {
    state.plan = plan;
    syncPlanUi();
    syncForm();
  }

  function selectWeeks(weeks) {
    state.weeks = weeks;
    $$('.tgab-freq-btn').forEach(function (btn) {
      btn.classList.toggle('is-active', parseInt(btn.getAttribute('data-weeks'), 10) === weeks);
    });
    /* Choosing a cadence implies wanting the subscription. */
    if (state.plan !== 'subscribe') {
      state.plan = 'subscribe';
      syncPlanUi();
    }
    syncForm();
  }

  if (els.planOnetime) {
    els.planOnetime.addEventListener('click', function () {
      selectPlan('onetime');
    });
  }

  if (els.planSub) {
    els.planSub.addEventListener('click', function () {
      selectPlan('subscribe');
    });
  }

  $$('.tgab-freq-btn').forEach(function (btn) {
    function activate(event) {
      event.preventDefault();
      event.stopPropagation();   // don't also fire the parent plan click
      if (btn.classList.contains('is-unavailable')) return;
      selectWeeks(parseInt(btn.getAttribute('data-weeks'), 10));
    }
    btn.addEventListener('click', activate);
    btn.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') activate(event);
    });
  });

  /* ------------------------------------------------------------ mode tabs */

  function setMode(mode) {
    state.mode = mode;
    $$('[data-tgab-mode]').forEach(function (el) {
      if (!el.classList.contains('tgab-mode')) return;
      var active = el.getAttribute('data-tgab-mode') === mode;
      el.classList.toggle('is-active', active);
      el.setAttribute('aria-selected', String(active));
    });
    if (els.panelBreed) els.panelBreed.hidden = mode !== 'breed';
    if (els.panelChart) els.panelChart.hidden = mode !== 'chart';

    /* Switching mode abandons the other mode's size choice, so the submitted
       variant always matches what is on screen. */
    clearSelection();
    hideWarning();
    syncForm();
  }

  function clearSelection() {
    state.sizeKey = null;
    state.breed = null;
    if (els.breedInput) els.breedInput.value = '';
    if (els.step2) els.step2.hidden = true;
    if (els.weightGrid) els.weightGrid.innerHTML = '';
    if (els.result) els.result.hidden = true;
    $$('.tgab-chart-card').forEach(function (card) {
      card.classList.remove('is-active');
      card.setAttribute('aria-pressed', 'false');
    });
    closeSuggestions();
  }

  $$('[data-tgab-mode]').forEach(function (el) {
    el.addEventListener('click', function (event) {
      event.preventDefault();
      setMode(el.getAttribute('data-tgab-mode'));
    });
  });

  /* -------------------------------------------------------- recommendation */

  function renderResult(sizeKey, breedName) {
    var size = sizeByKey(sizeKey);
    if (!size || !els.result) return;

    if (els.resultBadge) {
      els.resultBadge.setAttribute('data-size', sizeKey);
      var sizeText = els.resultBadge.querySelector('.tgab-result__badge-size');
      var colorText = els.resultBadge.querySelector('.tgab-result__badge-color');
      if (sizeText) sizeText.textContent = sizeKey;
      if (colorText) colorText.textContent = size.color.toUpperCase();
    }

    if (els.resultCopy) {
      els.resultCopy.innerHTML = '';
      els.resultCopy.appendChild(document.createTextNode('We recommend size '));
      var strong = document.createElement('strong');
      strong.textContent = size.label;
      els.resultCopy.appendChild(strong);
      els.resultCopy.appendChild(
        document.createTextNode(
          ' for your ' + displayBreed(breedName) + ' based on their breed and weight range.'
        )
      );
    }

    els.result.hidden = false;
  }

  function selectWeight(button, sizeKey, breedName) {
    $$('.tgab-weight-btn').forEach(function (btn) {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-pressed', 'false');
    });
    button.classList.add('is-active');
    button.setAttribute('aria-pressed', 'true');

    state.sizeKey = sizeKey;
    renderResult(sizeKey, breedName);
    syncForm();
  }

  function renderWeightRanges(breed) {
    var ranges = weightRangesFor(breed);
    if (!els.weightGrid) return;

    els.weightGrid.innerHTML = '';
    if (els.result) els.result.hidden = true;
    state.sizeKey = null;

    ranges.forEach(function (entry) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'tgab-weight-btn';
      button.setAttribute('aria-pressed', 'false');
      button.textContent = entry.range;
      button.addEventListener('click', function () {
        selectWeight(button, entry.size, breed.name);
      });
      els.weightGrid.appendChild(button);
    });

    if (els.step2) els.step2.hidden = false;

    if (ranges.length === 1) {
      selectWeight(els.weightGrid.firstChild, ranges[0].size, breed.name);
    } else {
      syncForm();
    }
  }

  /* ---------------------------------------------------------- breed search */

  function openSuggestions() {
    if (!els.suggestions) return;
    els.suggestions.hidden = false;
    els.breedInput.setAttribute('aria-expanded', 'true');
  }

  function closeSuggestions() {
    if (!els.suggestions) return;
    els.suggestions.hidden = true;
    els.breedInput.setAttribute('aria-expanded', 'false');
    state.highlighted = -1;
  }

  function suggestionNodes() {
    return $$('.tgab-suggestion');
  }

  function highlight(index) {
    var nodes = suggestionNodes();
    if (!nodes.length) return;
    state.highlighted = Math.max(0, Math.min(index, nodes.length - 1));
    nodes.forEach(function (node, i) {
      node.classList.toggle('is-highlighted', i === state.highlighted);
    });
    nodes[state.highlighted].scrollIntoView({ block: 'nearest' });
  }

  function chooseBreed(breed) {
    state.breed = breed;
    els.breedInput.value = breed.name;
    closeSuggestions();
    renderWeightRanges(breed);
    hideWarning();
  }

  function addGroupLabel(text) {
    var label = document.createElement('p');
    label.className = 'tgab-suggestions__group';
    label.textContent = text;
    els.suggestions.appendChild(label);
  }

  function addSuggestion(breed, query) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'tgab-suggestion';
    button.setAttribute('role', 'option');

    /* Emphasise the typed portion, as the design shows for "lab". */
    var at = breed.name.toLowerCase().indexOf(query.toLowerCase());
    if (at === -1) {
      button.textContent = breed.name;
    } else {
      button.appendChild(document.createTextNode(breed.name.slice(0, at)));
      var mark = document.createElement('mark');
      mark.textContent = breed.name.slice(at, at + query.length);
      button.appendChild(mark);
      button.appendChild(document.createTextNode(breed.name.slice(at + query.length)));
    }

    button.addEventListener('click', function (event) {
      event.stopPropagation();
      chooseBreed(breed);
    });
    els.suggestions.appendChild(button);
  }

  function addMixedBreedNote() {
    var mixed = null;
    for (var i = 0; i < breeds.length; i++) {
      var name = breeds[i].name.toLowerCase();
      if (name === 'mixed breed' || name === 'mutt') {
        mixed = breeds[i];
        break;
      }
    }
    if (!mixed) return;

    var note = document.createElement('p');
    note.className = 'tgab-suggestions__note';
    var strong = document.createElement('strong');
    strong.textContent = "Don't see your dog's breed? ";
    note.appendChild(strong);
    note.appendChild(document.createTextNode('Mutts and mixed breeds size by weight range. '));

    var link = document.createElement('button');
    link.type = 'button';
    link.className = 'tgab-link';
    link.textContent = 'Select Mixed Breed';
    link.addEventListener('click', function (event) {
      event.stopPropagation();
      chooseBreed(mixed);
    });
    note.appendChild(link);
    note.appendChild(document.createTextNode(' to continue.'));
    els.suggestions.appendChild(note);
  }

  function renderSuggestions(query) {
    var needle = query.toLowerCase().trim();
    var starts = [];
    var contains = [];

    breeds.forEach(function (breed) {
      var name = breed.name.toLowerCase().trim();
      if (name.indexOf(needle) === 0) starts.push(breed);
      else if (name.indexOf(needle) !== -1) contains.push(breed);
    });

    els.suggestions.innerHTML = '';

    if (!starts.length && !contains.length) {
      var hint = document.createElement('p');
      hint.className = 'tgab-suggestions__hint';
      hint.textContent = 'No matches found. Please try a different term.';
      els.suggestions.appendChild(hint);
      addMixedBreedNote();
      return;
    }

    starts.forEach(function (breed) {
      addSuggestion(breed, query);
    });

    /* Secondary matches get their own heading, per the design. */
    if (contains.length) {
      addGroupLabel('You might also mean:');
      contains.forEach(function (breed) {
        addSuggestion(breed, query);
      });
    }

    addMixedBreedNote();
    highlight(0);
  }

  els.breedInput.addEventListener('focus', function () {
    if (els.breedInput.value.trim().length >= MIN_QUERY_LENGTH) openSuggestions();
  });

  els.breedInput.addEventListener('input', function () {
    var value = els.breedInput.value;

    if (state.breed && value !== state.breed.name) {
      state.breed = null;
      state.sizeKey = null;
      if (els.step2) els.step2.hidden = true;
      if (els.weightGrid) els.weightGrid.innerHTML = '';
      if (els.result) els.result.hidden = true;
      syncForm();
    }

    if (value.trim().length < MIN_QUERY_LENGTH) {
      closeSuggestions();
      return;
    }

    openSuggestions();
    renderSuggestions(value);
  });

  els.breedInput.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeSuggestions();
      return;
    }
    if (els.suggestions.hidden) return;

    var nodes = suggestionNodes();
    if (!nodes.length) return;

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      highlight(state.highlighted + 1);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      highlight(state.highlighted - 1);
    } else if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      if (state.highlighted >= 0) nodes[state.highlighted].click();
    }
  });

  document.addEventListener('click', function (event) {
    if (!els.suggestions || els.suggestions.hidden) return;
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('.tgab-search-wrap')) return;
    closeSuggestions();
  });

  /* ------------------------------------------------------ direct size chart */

  $$('.tgab-chart-card').forEach(function (card) {
    var key = card.getAttribute('data-size');
    var variant = variantForSize(key);

    if (!variant || !variant.available) {
      card.disabled = true;
      return;
    }

    card.addEventListener('click', function () {
      $$('.tgab-chart-card').forEach(function (other) {
        other.classList.remove('is-active');
        other.setAttribute('aria-pressed', 'false');
      });
      card.classList.add('is-active');
      card.setAttribute('aria-pressed', 'true');
      state.sizeKey = key;
      hideWarning();
      syncForm();
    });
  });

  /* --------------------------------------------------------------- quantity */

  $$('[data-tgab-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var current = parseInt(els.quantity.value, 10) || 1;
      var next = btn.getAttribute('data-tgab-qty') === 'plus' ? current + 1 : current - 1;
      els.quantity.value = Math.max(1, next);
    });
  });

  /* ----------------------------------------------------------------- submit */

  /* `<product-form>` bails out when the button reports aria-disabled, so an
     incomplete box never posts. We only add the explanation. */
  els.submit.addEventListener('click', function (event) {
    if (isComplete()) return;
    event.preventDefault();
    showWarning(missingReason());
  });

  els.form.addEventListener('submit', function (event) {
    if (!isComplete()) {
      event.preventDefault();
      showWarning(missingReason());
    }
  });

  /* -------------------------------------------------------------------- init */

  syncPlanUi();
  syncForm();
})();
